import React, { useState } from "react";
import { useUsers } from "../../context/UserContext";
import Layout from "../../components/layout/Layout";
import UserCard from "../../components/users/UserCard";
import { PlusOutlined, SortAscendingOutlined, FilterOutlined } from '@ant-design/icons';
import { Modal, Button, Input, Select } from "antd";

const { Option } = Select;

const UsersPage = () => {
  const { users, loading, addUser, deleteUser } = useUsers();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    phone: "",
    role: "user",
    status: "active",
  });

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setNewUser({
      name: "",
      email: "",
      role: "user",
      status: "active",
    });
  };

  const handleSave = () => {
    addUser(newUser);
    handleCloseModal();
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Layout>
      <div className="mt-16 ml-64">
        {/* Üst Alan */}
        <div className="flex justify-between items-center p-4 bg-white shadow-md rounded-lg mb-4">
          <h2 className="text-xl font-semibold">Kullanıcılar</h2>
          <div className="flex gap-4 items-center flex-grow justify-center">
            <input
              type="text"
              placeholder="Kullanıcı Ara..."
              className="border border-gray-300 rounded px-2 py-1 focus:outline-none w-1/2"
            />
          </div>
          <div className="flex gap-4 items-center">
            <div className="flex items-center gap-1">
              <SortAscendingOutlined />
              <select className="border border-gray-300 rounded px-2 py-1 focus:outline-none">
                <option value="asc">A-Z</option>
                <option value="desc">Z-A</option>
              </select>
            </div>
            <div className="flex items-center gap-1">
              <FilterOutlined />
              <select className="border border-gray-300 rounded px-2 py-1 focus:outline-none">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
              </select>
            </div>
            <button
              className="bg-gray-800 text-white px-4 py-2 rounded hover:bg-gray-600 flex items-center gap-2"
              onClick={handleOpenModal}
            >
              <PlusOutlined /> Kullanıcı Ekle
            </button>
          </div>
        </div>

        {/* Kart Alanı */}
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {users.map((user) => (
            <UserCard
              key={user.id}
              user={user}
              onDelete={() => deleteUser(user._id)}
            />
          ))}
        </div>

        {/* Modal */}
        <Modal
          title="Yeni Kullanıcı Ekle"
          visible={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
        >
          <div className="grid grid-cols-2 gap-4">
            <Input
              placeholder="İsim Soyisim"
              value={newUser.name}
              onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
            />
            <Input
              placeholder="Email"
              value={newUser.email}
              onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
            />
            <Input
              placeholder="Telefon"
              value={newUser.phone}
              onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })}
            />
            <Select
              placeholder="Rol Seçiniz"
              // value={newUser.role}
              onChange={(value) => setNewUser({ ...newUser, role: value })}
            >
              <Option value="user">Kullanıcı</Option>
              <Option value="manager">Yönetici</Option>
              <Option value="admin">Admin</Option>
            </Select>
            <Select
              placeholder="Durum"
              value={newUser.status}
              onChange={(value) => setNewUser({ ...newUser, status: value })}
            >
              <Option value="active">Aktif</Option>
              <Option value="inactive">Pasif</Option>
            </Select>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={handleCloseModal} className="bg-red-500 text-white hover:bg-red-600">
              Cancel
            </Button>
            <Button type="primary" onClick={handleSave} className="bg-black text-white hover:bg-gray-800">
              Save
            </Button>
          </div>
        </Modal>
      </div>
    </Layout>
  );
};

export default UsersPage;
